import { Box, Icons, Stack, Text, palette } from '@solvhealth/jigsaw-v1';
import { Modal } from '@solvhealth/jigsaw-v1';
import React, { useEffect, useState } from 'react';
import { Hidden } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import Slot from '@solvhealth/types/interfaces/Location/Slot';
import NearbyLocationCard from '~/components/ClinicDetailPageFlexible/components/BookModule/components/variants/NearbyBook/NearbyLocationCard';
import { NearbyLocations } from '~/components/ClinicDetailPageFlexible/ContextProviders';
import dataTestIds from '~/test/test-ids';

type Props = {
  handleRequestAppointment: (location: LocationInterface, slot: Slot) => void;
  nearbyLocations: NearbyLocations | undefined;
  nearbyVariation: string;
  setViewableSlots: React.Dispatch<React.SetStateAction<any>>;
  referringLocation: LocationInterface;
  isMobileView: boolean;
};

const Separator = styled.hr.withConfig({ componentId: 'sc-c7hc4r-0' })`
  border-top: 1px solid ${palette.gray[200]};
  margin-top: 16px;
`;

const MobileNearbyContainer = ({
  handleRequestAppointment,
  nearbyLocations,
  setViewableSlots,
  referringLocation,
  isMobileView,
  nearbyVariation,
}: Props) => {
  const [showNearbyModal, setShowNearbyModal] = useState<boolean>(false);

  useEffect(() => {
    let timer: number = 0;
    if (!isEmpty(nearbyLocations?.connect)) {
      timer = setTimeout(() => {
        setShowNearbyModal(true);
      }, 10000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (isEmpty(nearbyLocations?.connect)) {
    return null;
  }

  return (
    <Hidden mdUp>
      <div data-testid={dataTestIds.cdp.nearbyBookModule}>
        {showNearbyModal && (
          <Modal
            alignment="left"
            onClose={() => {
              setShowNearbyModal(false);
            }}
            open={showNearbyModal}
            title="This clinic is not bookable on Solv"
            variant="short"
          >
            <Box>
              <Separator />
              <Stack>
                <Box mb={2} mt={3}>
                  <Text variant="h4">Need care ASAP?</Text>
                  <Text color="gray-500" variant="body">
                    View other instant-book clinics nearby
                  </Text>
                </Box>
                {nearbyLocations?.connect?.map(
                  (nearbyLocation: LocationInterface, index: number) => (
                    <Stack key={nearbyLocation.id} mb={2}>
                      <NearbyLocationCard
                        handleRequestAppointmentClick={handleRequestAppointment}
                        index={index}
                        isMobileView={isMobileView}
                        location={nearbyLocation}
                        nearbyVariation={nearbyVariation}
                        referringLocation={referringLocation}
                        setViewableSlots={setViewableSlots}
                      />
                    </Stack>
                  )
                )}
              </Stack>
            </Box>
          </Modal>
        )}
        <Stack space={2}>
          <Box
            bg="gray-100"
            border="solid 1px gray-100"
            borderRadius="sm"
            display="flex"
            mb={2}
            px={1}
            py={2}
            textColor="gray-500"
          >
            <Icons.AlertCircle color="gray-500" px={1} />
            <Text color="gray-500" variant="subtitle">
              This location is not bookable on Solv.
            </Text>
          </Box>
          <Box>
            <Text variant="h4">Need care ASAP?</Text>
            <Text color="gray-500" variant="body2">
              View other instant-book clinics nearby
            </Text>
          </Box>
          {nearbyLocations?.connect?.map((nearbyLocation: LocationInterface, index: number) => (
            <Stack key={nearbyLocation.id} mb={2}>
              <NearbyLocationCard
                handleRequestAppointmentClick={handleRequestAppointment}
                index={index}
                isMobileView={isMobileView}
                location={nearbyLocation}
                nearbyVariation={nearbyVariation}
                referringLocation={referringLocation}
                setViewableSlots={setViewableSlots}
              />
            </Stack>
          ))}
        </Stack>
      </div>
    </Hidden>
  );
};

export default MobileNearbyContainer;
